import React from 'react';

const SvgSchedule = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="51" viewBox="0 0 50 51" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.25 1.79688C17.25 0.804443 16.3916 0 15.333 0C14.2744 0 13.4165 0.804443 13.4165 1.79688V4.67188H6.1333C2.74609 4.67188 0 7.24622 0 10.4219V44.9219C0 48.0975 2.74609 50.6719 6.1333 50.6719H42.9331C46.3208 50.6719 49.0669 48.0975 49.0669 44.9219V10.4219C49.0669 7.24622 46.3208 4.67188 42.9331 4.67188H35.6499V1.79688C35.6499 0.804443 34.7915 0 33.7329 0C32.6743 0 31.8164 0.804443 31.8164 1.79688V4.67188H17.25V1.79688ZM31.8164 8.26562H17.25V11.5863C17.25 12.5787 16.3916 13.3832 15.333 13.3832C14.2744 13.3832 13.4165 12.5787 13.4165 11.5863V8.26562H6.1333C4.86328 8.26562 3.8335 9.23096 3.8335 10.4219V20.125H45.2334V10.4219C45.2334 9.23096 44.2036 8.26562 42.9331 8.26562H35.6499V11.6868C35.6499 12.6791 34.7915 13.4836 33.7329 13.4836C32.6743 13.4836 31.8164 12.6791 31.8164 11.6868V8.26562ZM3.8335 23.7188H45.2334V44.9219C45.2334 46.1128 44.2036 47.0781 42.9331 47.0781H6.1333C4.86328 47.0781 3.8335 46.1128 3.8335 44.9219V23.7188Z"
      fill="#EFEFEF"
    />
  </svg>
);

export default SvgSchedule;
